import React, { useContext, useState, useEffect } from "react";
import {
  Stack,
  Grid2 as Grid,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
// date
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import moment from "moment";
//Icons
import { BiMinusCircle } from "react-icons/bi";

//Srcs
import "../../../Style/dialogStyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

import DatePickerForDialog from "../../Include/SelecteDatePicker/DatePickerForDialog";
import { CREATE_STUDENT, UPDATE_STUDENT } from "../../../Schema/Student";

import {
  SelectAcademicYear,
  SelectSchool,
  SelectClassByAcademicYearAndSchool,
} from "../../../Function/DynamicSelect";

export default function StudentForm({
  open,
  handleClose,
  setRefetch,
  editData,
  dialogTitle,
}) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [schoolVal, setSchoolVal] = useState({ id: "", title: "" });
  const [attendanceClassId, setAttendanceClassId] = useState({
    id: "",
    title: "",
  });

  //======================== Create =========================
  const [createStudent] = useMutation(CREATE_STUDENT, {
    onCompleted: ({ createStudent }) => {
      // console.log("createStudent::", createStudent);
      setLoading(false);
      if (createStudent?.is_success === true) {
        setAlert(true, "success", createStudent?.message);
        handleClose();
        resetForm();
        // setRefetch();
      } else {
        setAlert(true, "error", createStudent?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("error", error);
      setAlert(true, "error", error?.message);
    },
  });
  //======================== Update =========================
  const [updateStudent] = useMutation(UPDATE_STUDENT, {
    onCompleted: ({ updateStudent }) => {
      // console.log("updateStudent::", updateStudent);
      setLoading(false);
      if (updateStudent?.is_success === true) {
        setAlert(true, "success", updateStudent?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updateStudent?.message);
        console.log("eiior", updateStudent?.message)
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
      console.log("error", error)
    },
  });

  //fromik

  const CheckValidation = Yup.object().shape(

    dialogTitle === "Create" ? ({
      student_id: Yup.string().required(t("require")),
      full_name_kh: Yup.string().required(t("require")),
      full_name_latin: Yup.string().required(t("require")),
      gender: Yup.string().required(t("require")),
      date_of_birth: Yup.string(),
      current_address: Yup.string(),
      phone_number: Yup.string(),
      remark: Yup.string(),
      attend_class_id: Yup.string().required(t("require"))
    }) : ({
      student_id: Yup.string().required(t("require")),
      full_name_kh: Yup.string().required(t("require")),
      full_name_latin: Yup.string().required(t("require")),
      gender: Yup.string().required(t("require")),
      date_of_birth: Yup.string(),
      current_address: Yup.string(),
      phone_number: Yup.string(),
      remark: Yup.string(),
      attend_class_id: Yup.string()
    })


  );

  const formik = useFormik({
    initialValues: {
      student_id: "",
      full_name_kh: "",
      full_name_latin: "",
      gender: "Male",
      date_of_birth: moment(),
      phone_number: "",
      current_address: "",
      remark: "",
      attend_class_id: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (submitValues) => {
      setLoading(true);
      if (dialogTitle === "Create") {
        createStudent({
          variables: {
            input: {
              ...submitValues,
            },
          },
        });
      } else {

        updateStudent({
          variables: {
            id: editData?._id,
            input: {
              student_id: submitValues?.student_id,
              full_name_kh: submitValues?.full_name_kh,
              full_name_latin: submitValues?.full_name_latin,
              gender: submitValues?.gender,
              date_of_birth: submitValues?.date_of_birth,
              current_address: submitValues?.current_address,
              phone_number: submitValues?.phone_number,
              remark: submitValues?.remark,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  // console.log("errors", errors)
  // console.log("values", values)

  useEffect(() => {
    setFieldValue("attend_class_id", attendanceClassId?.id ?? null);
  }, [attendanceClassId?.id]);

  useEffect(() => {
    if (dialogTitle === "Create") {
      resetForm();
    }
  }, [open]);

  // console.log("editData",editData)

  useEffect(() => {
    if (editData && dialogTitle === "Update") {
      setFieldValue("student_id", editData?.student_id);
      setFieldValue("full_name_kh", editData?.full_name_kh);
      setFieldValue("full_name_latin", editData?.full_name_latin);
      setFieldValue("gender", editData?.gender);
      setFieldValue("date_of_birth", editData?.date_of_birth ? editData?.date_of_birth : moment());
      setFieldValue("phone_number", editData?.phone_number);
      setFieldValue("current_address", editData?.current_address);
      setFieldValue("remark", editData?.remark);
    }
  }, [editData, dialogTitle]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography
              className={language === "en" ? "dialog-title" : "dialog-title-kh"}
            >
              {dialogTitle === "Create"
                ? t("dialog_title_create_student")
                : t("dialog_title_update_student")}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("student_id")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  inputProps={{ min: 0 }}
                  onFocus={(e) => e?.target?.select()}
                  placeholder={t("student_id")}
                  {...getFieldProps("student_id")}
                  error={Boolean(touched.student_id && errors.student_id)}
                  helperText={touched.student_id && errors.student_id}
                />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("student_name")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder={t("student_name")}
                  {...getFieldProps("full_name_kh")}
                  error={Boolean(touched.full_name_kh && errors.full_name_kh)}
                  helperText={touched.full_name_kh && errors.full_name_kh}
                />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("student_name_en")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder={t("student_name_en")}
                  {...getFieldProps("full_name_latin")}
                  error={Boolean(
                    touched.full_name_latin && errors.full_name_latin
                  )}
                  helperText={touched.full_name_latin && errors.full_name_latin}
                />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("label_gender")}
                </Typography>
                <FormControl size="small" fullWidth>
                  <Select
                    value={values?.gender}
                    onChange={(e) => setFieldValue("gender", e.target.value)}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("dob")}
                </Typography>
                <DatePickerForDialog date={values?.date_of_birth}
                  setDate={(e) => setFieldValue("date_of_birth", e)} />

              </Grid>
              <Grid size={{ xs: 6 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("label_tel")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder={t("label_tel")}
                  {...getFieldProps("phone_number")}
                  error={Boolean(touched.phone_number && errors.phone_number)}
                  helperText={touched.phone_number && errors.phone_number}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("current_address")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder={t("current_address")}
                  {...getFieldProps("current_address")}
                  error={Boolean(
                    touched.current_address && errors.current_address
                  )}
                  helperText={touched.current_address && errors.current_address}
                />
              </Grid>
              {dialogTitle === "Update" ? null : (
                <>
                  <Grid size={{ xs: 6 }}>
                    <Typography
                      className={
                        language === "en" ? "field-title" : "field-title-kh"
                      }
                    >
                      {t("academic_year")}
                    </Typography>
                    <SelectAcademicYear
                      selectedVal={academicYearVal}
                      setSelectedVal={setAcademicYearVal}
                    />
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Typography
                      className={
                        language === "en" ? "field-title" : "field-title-kh"
                      }
                    >
                      {t("school")}
                    </Typography>
                    <SelectSchool
                      selectedVal={schoolVal}
                      setSelectedVal={setSchoolVal}
                      disabled={academicYearVal?.id ? false : true}
                    />
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <Typography
                      className={
                        language === "en" ? "field-title" : "field-title-kh"
                      }
                    >
                      {t("class")}
                    </Typography>
                    <SelectClassByAcademicYearAndSchool
                      academicYearId={academicYearVal?.id}
                      schoolId={schoolVal?.id}
                      selectedVal={attendanceClassId}
                      setSelectedVal={setAttendanceClassId}
                      disabled={
                        academicYearVal?.id && schoolVal?.id ? false : true
                      }
                    />
                    {!!errors.attend_class_id && touched.attend_class_id && (
                      <FormHelperText error id="outlined-adornment-password">
                        {errors.attend_class_id}
                      </FormHelperText>
                    )}
                  </Grid>
                </>
              )}

              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("remark")}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder={t("remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
      <DialogActions>
        <Grid size={{ xs: 12 }} className="create-container">
          {loading ? (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
            >
              {t("loading")}
            </Button>
          ) : (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
              onClick={handleSubmit}
            >
              {dialogTitle === "Create" ? t("btn-create") : t("btn-update")}
            </Button>
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
